
import { useLanguage } from '@/hooks/useLanguage';

interface NewsErrorProps {
  error: string | null;
}

export function NewsError({ error }: NewsErrorProps) {
  const { t } = useLanguage();
  
  return (
    <div className="text-center py-10">
      <p className="text-destructive">{t('news.error')}: {error}</p>
    </div>
  );
}
